<template>
  <transition name="modal">
    <div class="modal-mask" @click="$emit('close')">
      <div class="modal-wrapper" role="document" style="overflow-y: auto; position: absolute">
        <div class="modal-container modal-dialog">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <div class="row">
                <div class="col-xs-10">Edit Category</div>
                <div class="col-xs-2">
                  <button
                    type="button"
                    class="close"
                    @click="$emit('close')"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/Close.svg'"
                      width="50px"
                      height="auto"
                      class="icon"
                    />
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <template v-if="category">
                <div class="form-group">
                  <label for="buttonUrlInput">Category Name</label>
                  <input
                    type="text"
                    ref="category"
                    class="form-control"
                    id="categoryNameInput"
                    aria-describedby="Category Name"
                    placeholder="Category Name"
                    v-model="category.name"
                  />
                </div>
              </template>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="editCategory">Save</button>
              <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import api from '@/api'
export default {
  props: ['category'],
  mounted: function () {
    this.$refs.category.focus()

    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  },
  methods: {
    editCategory: function () {
      let vm = this
      let data = {
        name: vm.category.name,
        id: vm.category.id
      }
      vm.$store.dispatch('loading')
      api.editCategory(data, function (error, response) {
        vm.$store.dispatch('loading')
        vm.$emit('close')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/event/ecommerce-category-edit.vue